// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconShopPath = 'M17.562 16.413 19.147 5h-5.149c0-2.206-1.794-4-4-4-2.205 0-4 1.794-4 4H.85l1.585 11.412A3.012 3.012 0 0 0 5.407 19h9.183a3.013 3.013 0 0 0 2.972-2.587ZM3.147 7H16.85l-1.27 9.137a1.002 1.002 0 0 1-.99.863H5.407c-.497 0-.923-.371-.99-.863L3.146 7Zm8.851-2c0-1.103-.897-2-2-2s-2 .897-2 2h4Zm0 4c0 1.103-.897 2-2 2s-2-.897-2-2h-2c0 2.206 1.795 4 4 4 2.206 0 4-1.794 4-4h-2Z';
var IconShop = baseIcon('IconShop', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconShopPath
});
export default IconShop;
//# sourceMappingURL=index.js.map